import { render } from "./bussiness.vue?vue&type=template&id=628548f9&scoped=true&ts=true"
import script from "./bussiness.vue?vue&type=script&lang=ts"
export * from "./bussiness.vue?vue&type=script&lang=ts"

import "./bussiness.vue?vue&type=style&index=0&id=628548f9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-628548f9"]])

export default __exports__